<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters" style="display:none">
        <el-form-item>
          <el-input v-model="filters.q" placeholder="搜索"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getList">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="listdata" highlight-current-row v-loading="loading" @selection-change="selsChange"
      style="width: 100%;">
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="{row}">
          <span :style="{color:row.Statclr}">{{row.Stats}}</span>
          <!-- <span v-if="row.Stat == 1" style="color:green">已到账</span>
          <span v-else-if="row.Stat == 2" style="color:red">信息有误</span>
          <span v-else-if="row.Stat == 3" style="color:#aaa">撤回</span>
          <span v-else>等待处理</span> -->
        </template>
      </el-table-column>
      <el-table-column label="金额" align="center" width="150">
        <template slot-scope="{row}">
          <div class="wxmpTit">
            <el-button type="text" style="margin-right: 15px;" v-if="row.Isbank>0" @click="$refs.txTaxTips.show(row.Imgs)">转账信息</el-button>
            <img :src="row.Imgsrc" v-else />
            <span style="color:#f60;font-weight:bold">{{ row.Amounts }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Timestr" label="申请时间" width="180">
      </el-table-column>
      <el-table-column prop="Desc" label="描述">
      </el-table-column>
      <el-table-column prop="Nickup" label="处理人" width="120">
      </el-table-column>
      <el-table-column prop="Timeupstr" label="处理时间" width="180">
      </el-table-column>
      <el-table-column prop="Remark" label="备注">
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template scope="{row}">
          <el-button-group>
            <el-button v-if="row.Stat == 0" size="mini" type="warning" @click="revokeBackFun(row)">撤回</el-button>
            <!-- <el-button size="small" type="danger" @click="handleDel(row)">删除</el-button> -->
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination layout="prev, pager, next" :current-page.sync="filters.page" :total="total" :page-size="limit"
        @current-change="getList" style="float:right;">
      </el-pagination>
    <txTaxTips ref="txTaxTips" />
    </el-col>
  </section>
</template>

<script>
import txTaxTips from '@/views/ruis/user/txTaxTips';
export default {
  components: { txTaxTips },
  data () {
    return {
      filters: {
        page: 1,
        s: '',
        q: ''
      },
      loading: false,
      total: 0,
      limit: 0,
      listdata: [],
      sels: [],//列表选中列
    }
  },
  mounted () {
    this.getList();
  },
  methods: {
    //获取列表
    getList () {
      this.loading = true;
      //NProgress.start();
      this.$post('/user/txs', this.filters).then((res) => {
        console.log(res);
        this.loading = false;
        this.listdata = res.data.Data;
        this.total = res.data.Total;
        this.limit = res.data.Size;
        this.filters.page = res.data.Page;
        //NProgress.done();
      }).catch(err => {
        this.$message({
          message: err.response.data || '服务器错误',
          type: 'error'
        });
      });
    }, selsChange (sels) {
      this.sels = sels;
    }, handleAdd () {

    }, handleEdit () {

    }, handleDel () {
      this.$confirm('确定要删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
      });
    }, batchRemove () {

    }, revokeBackFun (row) {
      this.$confirm('确定要撤回提现吗?(每月只能一次)', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('/user/tx-revoke', {xid:row.Xid}).then((res) => {
          console.log(res);
          this.getList();
          //NProgress.done();
        }).catch(err => {
          this.$message({
            message: err.response.data || '服务器错误',
            type: 'error'
          });
        });
      });
    }
  }
}

</script>

<style scoped>
.wxmpTit {
  line-height: 60px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.wxmpTit img {
  width: 60px;
  height: 60px;
  float: left;
  margin-right: 10px;
}</style>


// WEBPACK FOOTER //
// TxList.vue?8abe5f72